"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../../common/components/materials/KansaTgtJigyoBasicInfo"));
var _kansaResultActions = require("../kansaResultActions");
var _ShitekiJiko = _interopRequireDefault(require("./components/ShitekiJiko"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledReturnButton = (0, _styles.styled)(_CButton.default)({
  margin: '0 0 0 auto'
});
const StyledBlockSpace = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1)
  };
});
class ShitekiKaizenplanJissekiEntryResult extends _react.default.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      intl,
      shitekiList,
      shitekiEntriesList,
      btnProps,
      kansaTgtJigyoBasicInfo,
      mailErrMsg
    } = this.props;

    // 戻るボタン
    const returnButton = /*#__PURE__*/_react.default.createElement(StyledReturnButton, {
      onClick: btnProps.onClick(true),
      autoWidth: true,
      negative: true
    }, btnProps.label);
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SHITEKI_KAIZENPLAN_ZISSEKI_RESULT
      }),
      actions: [returnButton]
    }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 9
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: "register",
      supplement: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, mailErrMsg))
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 3
      },
      align: "right"
    }, returnButton), /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
      data: kansaTgtJigyoBasicInfo && typeof kansaTgtJigyoBasicInfo === 'object' ? kansaTgtJigyoBasicInfo : {}
    }), shitekiList.map((item, index) => {
      const dispIndex = index + 1;
      return /*#__PURE__*/_react.default.createElement(StyledBlockSpace, {
        key: dispIndex
      }, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
        title: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_SHITEKI_JIKO
        }) + dispIndex
      }, /*#__PURE__*/_react.default.createElement(_ShitekiJiko.default, {
        shitekiJiko: item,
        shitekiEntriesList: shitekiEntriesList,
        kansaTgtNendoNm: kansaTgtJigyoBasicInfo.kansaTgtNendoNm
      })));
    }))));
  }
}
const mapStateToProps = state => ({
  kansaInfo: state.kansaResult.kansaInfo,
  shitekiList: state.kansaResult.shitekiList,
  shitekiEntriesList: state.kansaResult.shitekiEntriesList,
  kansaTgtJigyoBasicInfo: state.kansaResult.kansaTgtJigyoBasicInfo,
  mailErrMsg: state.kansaResult.mailErrMsg
});
const mapDispatchToProps = dispatch => {
  return {
    setContent: content => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_CONTENT](content))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(ShitekiKaizenplanJissekiEntryResult));